import React from 'react';
import { FormCard, FormDescriptions } from '@purchase/supplier';
import { ProTablePlus } from '@bedrock/eed-react';
import type { IProTablePlusColumn } from '@bedrock/eed-react/lib/components/ProTablePlus/interface';
import type { RecordType } from '@bedrock/components/es/Table/interfaces';
import { CopyableNode } from '@mpc/common/src/components';
import type { AccidentDetailData } from '../constants';
import AttachmentItem from '../components/AttachmentItem';
import VendorCard from '../components/VendorCard';

type OrderRow = { $index: number; orderNo: string; demandName: string };

/** 关联单表格（序号 / 关联MPC三级单号 / 需求名称），内嵌于基本信息区块 */
const RelatedOrderTable = ({ detail }: { detail?: AccidentDetailData }) => {
  const orderNos = detail?.relatedOrderNos ?? [];
  if (orderNos.length === 0) {
    return <span>--</span>;
  }
  const rows: OrderRow[] = orderNos.map((orderNo, i) => ({
    $index: i + 1,
    orderNo,
    demandName: detail?.demandNames?.[i] ?? '--',
  }));
  const columns: IProTablePlusColumn<RecordType>[] = [
    { title: '序号', dataIndex: '$index', width: 60, render: (v) => v ?? '--' },
    { title: '关联MPC三级单号', dataIndex: 'orderNo', render: (v) => v || '--' },
    { title: '需求名称', dataIndex: 'demandName', render: (v) => v || '--' },
  ];
  return <ProTablePlus columns={columns} data={rows} pagination={false} />;
};

/** 区块1：事故基本信息 */
const BasicInfoBlock = ({ detail }: { detail?: AccidentDetailData }) => {
  return (
    <FormCard title="事故基本信息" proCardProps={{ expandable: true }}>
      <FormDescriptions columns={2} labelStyle={{ width: 180 }} margin={false}>
        <FormDescriptions.Item label="事故编号">
          <CopyableNode value={detail?.accidentNo} />
        </FormDescriptions.Item>
        <FormDescriptions.Item label="关联供应商名称" span={2}>
          {detail?.relatedVendors?.length ? (
            <div className="flex flex-wrap gap-2">
              {detail.relatedVendors.map((v, i) => (
                <VendorCard key={v.vendorId || i} vendor={v} />
              ))}
            </div>
          ) : (
            <span>--</span>
          )}
        </FormDescriptions.Item>

        <FormDescriptions.Item label="责任服务类型">
          <span className="[word-break:break-word]">
            {detail?.responsibleServiceTypeName || detail?.responsibleServiceType || '--'}
          </span>
        </FormDescriptions.Item>
        <FormDescriptions.Item label="关联服务类型">
          <span className="[word-break:break-word]">
            {detail?.relatedServiceTypes?.length ? detail.relatedServiceTypes.join('，') : '--'}
          </span>
        </FormDescriptions.Item>

        <FormDescriptions.Item label="供应商名称">
          <CopyableNode value={detail?.vendorName} />
        </FormDescriptions.Item>
        <FormDescriptions.Item label="供应商编码">
          <CopyableNode value={detail?.vendorId} />
        </FormDescriptions.Item>
        
        
        <FormDescriptions.Item label="关联单" span={2}>
          <RelatedOrderTable detail={detail} />
        </FormDescriptions.Item>

        <FormDescriptions.Item label="事故描述" span={2}>
          <span className="[word-break:break-word]">{detail?.description || '--'}</span>
        </FormDescriptions.Item>
      </FormDescriptions>
    </FormCard>
  );
};

export default BasicInfoBlock;
